import React, {useCallback} from 'react';
import ConfirmationDeleteList from "../../../../../../../components/utils/confirmation-delete-lists.jsx";
import Button from "../../../../../../../components/button/button.jsx";
import {FaGear} from "react-icons/fa6";
import {FaTrash} from "react-icons/fa";
import projectUtils from "../../../../../../../utils/project-utils.js";
import userService from "../../../../../../../services/web/user-service.js";

const DevicesActionsCellRenderer = ({node, setOpen, setDeviceSelected, setDevices, setShared, tabs, setChanges, remove}) => {
    const title = !node.data?.id ?
        "Salve o agente para obter acesso as configurações do contato" :
        "Configurações do contato";

    const onRemoveClick = useCallback(() => {
        ConfirmationDeleteList(() => {
            if (!node.data.id) {
                setDevices(prev => prev.filter(p => p.phone !== node.data.phone));
                setChanges('devices');
                return;
            }

            userService.hasAssociations(node.data.id)
                .then(({data}) => {
                    if (data.hasAssociations) {
                        projectUtils.swalErrorMessage("", "O dispositivo está associado a uma regra ou a um monitoramento.", "Ok");
                        return;
                    }

                    if (!!node.data.id && setShared) {
                        setShared(prev => ({
                            ...prev,
                            sharedDevice: prev.sharedDevice?.id === node.data.id ? null : prev.sharedDevice
                        }))
                    }

                    setDevices(prev => prev.filter(p => p.phone !== node.data.phone));
                    setChanges('devices');
                })
                .catch(error => {
                    console.error(error);
                    projectUtils.swalErrorMessage("", "Não foi possível prosseguir.", "Ok");
                })
        })

    }, [node]);

    const openModal = () => {
        if (!node.data.id) return;

        setOpen(true);
        setDeviceSelected(node.data.id);
    }

    return (
        <>
            <div className="flex gap-1 justify-center items-center h-full w-full">
                {
                    node.data.type === "CELULAR" &&
                    <Button className={"!w-[30px] !h-[25px] !p-0"} disabled={!node.data?.id || (tabs && !tabs.find(t => t.key === "user"))} title={title} onClick={() => openModal()}>
                        <FaGear />
                    </Button>
                }

                {
                    node.data.type !== "CELULAR" &&
                    <div style={{width: "35px"}}></div>
                }

                {
                    remove &&
                    <Button className={"w-[30px] !h-[25px] !p-0"} target={"danger"} title="Excluir contato" onClick={onRemoveClick}>
                        <FaTrash />
                    </Button>
                }
            </div>
        </>
    );
};

export default DevicesActionsCellRenderer;